import { jquery } from '../../../httpsnippet-lite/targets/javascript/jquery/client.js';
import { convertWithHttpSnippetLite } from '../../../utils/convertWithHttpSnippetLite.js';
/**
 * js/jquery
 */
export const jsJquery = {
    target: 'js',
    client: 'jquery',
    title: 'jQuery',
    generate(request) {
        // TODO: Write an own converter
        return convertWithHttpSnippetLite(jquery, request);
    },
};
